import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Image from 'global/Image';
import styled from 'styled-components';

const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60vh;
`;

const Img = styled(Image)`
  margin-bottom: 32px;
`;

const ContentWrapper = styled.div`
  text-align: center;

  ${Text} {
    text-align: center;
  }
`;

const ButtonDiscover = styled(Button).attrs({
  type: 'primary',
})`
  font-size: 16px;
  height: 44px;
  margin: auto;
  width: 200px;

  :hover {
    background: #3a3a3a;
    border-color: #3a3a3a;
  }
`;

const ButtonCompose = styled(Button)`
  font-size: 13px;
  height: 40px;
  margin: auto;
  width: 150px;
  border-radius: 4px;
  border: 1px solid #00ab6b;
  background: #ffffff;
  color: #00ab6b;
  font-weight: bold;

  svg {
    margin-right: 4px;
  }

  :hover,
  :focus {
    border: 1px solid #00ab6b;
    background: #ffffff;
    color: #00ab6b;
  }
`;

export {
  EmptyStateWrapper,
  Img,
  ContentWrapper,
  ButtonDiscover,
  ButtonCompose,
};
